<template>
    <button :disabled="loading" v-html="btnLabel" class="btn btn-danger btn-xs" @click="confirmDeleteCarrierDestinationPrice">
    </button>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "CarrierDestinationPriceDeleteButton",
    props: {
        carrierDestination: {
            type: Object,
            required: true,
        },
        carrierDestinationPrice: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        confirmDeleteCarrierDestinationPrice() {
            Swal.fire({
                title: this.$t("CarrierDestinationPriceDeleteButton.youSureToDelete"),
                text: this.$t("CarrierDestinationPriceDeleteButton.youCantUndo"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("CarrierDestinationPriceDeleteButton.delete"),
                cancelButtonText: this.$t("CarrierDestinationPriceDeleteButton.cancel"),
            }).then(result => {
                if (result.value) {
                    this.deleteCarrierDestinationPrice();
                }
            });
        },
        async deleteCarrierDestinationPrice() {
            try {
                this.loading = true;
                let response;
                if (this.carrierDestination.carrierAreaId) {
                    response = await this.$diceAPI.deleteCarrierAreaPrice(this.carrierDestination.carrierAreaId, this.carrierDestinationPrice);
                    this.$emit("editCarrierArea", response.data);
                } else {
                    response = await this.$diceAPI.deleteCarrierDestinationPrice(this.carrierDestinationPrice);
                    this.$emit("deleteCarrierDestinationPrice", response.data);
                }
                this.$toasted.success(this.$t("CarrierDestinationPriceDeleteButton.carrierDestinationPriceDeleted"), { icon: "check" });
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
    },
    computed: {
        btnLabel() {
            return this.loading ? "<i class='fa fa-spin fa-spinner'></i>" : "<i class='fa fa-times'></i>";
        },
    },
};
</script>

<style scoped>

</style>